/**
 * Project Configuration
 * Centralized configuration for project name and display settings
 * Can be overridden via environment variables
 */
import logger from "../lib/logger";

// Get project configuration from environment - REQUIRED, no defaults
const PROJECT_DISPLAY_NAME = process.env.REACT_APP_PROJECT_DISPLAY_NAME;
const CODE_SYSTEM_NAME = process.env.REACT_APP_CODE_SYSTEM_NAME;
const ADMIN_ROLE_NAME = process.env.REACT_APP_ADMIN_ROLE_NAME;
const ADMIN_PLATFORM_NAME = process.env.REACT_APP_ADMIN_PLATFORM_NAME;

// Validate required variables
if (!PROJECT_DISPLAY_NAME || !CODE_SYSTEM_NAME || !ADMIN_ROLE_NAME || !ADMIN_PLATFORM_NAME) {
  throw new Error('Missing required REACT_APP_* environment variables. Check .env file.');
}

// Fetch config from backend on app start (will override env vars if available)
let backendConfig = null;

export const fetchProjectConfig = async () => {
  try {
    // Import API from config (dynamic import to avoid circular dependency)
    const { API } = await import('../config');
    const response = await fetch(`${API}/config`);
    if (response.ok) {
      backendConfig = await response.json();
    }
  } catch (error) {
    logger.warn("Could not fetch project config from backend:", error);
  }
};

// Export config getters (use backend config if available, otherwise use env/defaults)
export const getProjectDisplayName = () => backendConfig?.project_display_name || PROJECT_DISPLAY_NAME;
export const getCodeSystemName = () => backendConfig?.code_system_name || CODE_SYSTEM_NAME;
export const getAdminRoleName = () => backendConfig?.admin_role_name || ADMIN_ROLE_NAME;
export const getAdminPlatformName = () => backendConfig?.admin_platform_name || ADMIN_PLATFORM_NAME;

// Export default values for immediate use (before backend config is loaded)
export const projectConfig = {
  projectDisplayName: PROJECT_DISPLAY_NAME,
  codeSystemName: CODE_SYSTEM_NAME,
  adminRoleName: ADMIN_ROLE_NAME,
  adminPlatformName: ADMIN_PLATFORM_NAME,
};

